import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import BaseNavigationTabs from 'components/Navigation/BaseNavigationTabs';
import BaseNavigationTabsButton from 'components/Navigation/BaseNavigationTabs/BaseNavigationTabsButton';
import {NavigationTabsPropsHelper} from 'components/Navigation/BaseNavigationTabs/types';

const NavigationTabsPartnerOverview: FC<NavigationTabsPropsHelper> = ({
    className,
    selection,
}) => {
    const {t} = useTranslation('Navigation.NavigationTabs');

    return (
        <BaseNavigationTabs className={className} selection={selection}>
            <BaseNavigationTabsButton
                href="/home/partner/"
                label={t('yourCompany.settings')}
                name="settings"
            />
            <BaseNavigationTabsButton
                href="/data/import/"
                label={t('yourCompany.dataImport')}
                name="dataImport"
            />
            <BaseNavigationTabsButton
                href="/data/export/"
                label={t('yourCompany.dataExport')}
                name="dataExport"
            />
            <BaseNavigationTabsButton
                href="/integrations/"
                label={t('yourCompany.integrations')}
                name="integrations"
            />
            <BaseNavigationTabsButton
                href="/home/early-access/"
                label={t('yourCompany.earlyAccess')}
                name="earlyAccess"
            />
            <BaseNavigationTabsButton
                href="/billing/prices/"
                label={t('yourCompany.billingAndPlan')}
                name="billingAndPlan"
            />
        </BaseNavigationTabs>
    );
};

export default NavigationTabsPartnerOverview;
